'use client'

import React, { HTMLAttributes, useEffect, useState } from 'react'
import { Loading } from '../Loading';
import { Locale } from '../../../i18n.config';

interface IOmioFormProps extends HTMLAttributes<HTMLDivElement> {
  lang: Locale;
};

export const OmioForm: React.FC<IOmioFormProps> = ({ lang }) => {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (!document.getElementById('travel-by-tains-script')) {
      const OmioScript = document.createElement('script');
      OmioScript.type = 'text/javascript'
      OmioScript.setAttribute('src', `https://ferret.cdn-goeuro.com/ferret-affiliates.js?v=${new Date().getTime()}`);
      OmioScript.setAttribute('id', `travel-by-tains-script`);
      document.head.appendChild(OmioScript);

      OmioScript.onload = () => {
        // const widget = document.getElementById('search-widget');
        // widget?.setAttribute('v-show', "true")
        setIsLoading(false);
      };
    }
  }, [])

  return (
    <div className={`w-full ${isLoading ? 'h-64' : 'h-auto'} flex items-center justify-center`}>
      <Loading isLoading={isLoading} />
      <div
        id='c-travel-guides-hero__widget-container'
        className={`${isLoading ? 'w-0' : 'w-full'}`}
      >
        {
          <div
            v-show={(!isLoading).toString()}
            id="search-widget"
            // @ts-expect-error 
            locale={lang}
            currency="eur"
            className="light-blue-theme"
            partner="affiliate_ir"
            country="IT"
            domain="it"
          >
          </div>
        }
      </div>
    </div>
  )
}